import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared.module';
import { DashboardRouterModule } from './dashboard-routing.module';
import { WidgetsComponentsModule } from 'src/app/components/kit/widgets/widgets-components.module';
import { FormsModule } from '@angular/forms';
import { DashboardComponent } from './main/dashboard.component';

// dashboard

const COMPONENTS = [DashboardComponent];

@NgModule({
	imports: [
		SharedModule,
		DashboardRouterModule,
		WidgetsComponentsModule,
		FormsModule,
	],
	declarations: [...COMPONENTS]
})
export class DashboardModule {}
